import React from "react"

import SectionOutputModal from "./SectionOutputModal"
import { FormControlLabel, Popover, Radio, RadioGroup } from "@mui/material"
import { COLORS } from "../../../../../utils"


import CloseIcon from "@mui/icons-material/Close"

const popoverStyles = {
  "& .MuiPopover-paper": {
    backgroundColor: COLORS.BLACK800,
    width: 282,
    borderRadius: "8px",
    color: COLORS.WHITE,
    fontSize: 14,
    position: "relative",
    mt: "9px",
    padding: "12px",
    overflow: "visible",
    "&::before": {
      content: "''",
      position: "absolute",
      top: "-2px",
      left: "49.5%",
      transform: "translateX(-50%)",
      width: 14,
      height: 14,
      bgcolor: COLORS.BLACK800,
      transformOrigin: "center",
      rotate: "45deg",
      zIndex: 0,
      boxShadow: 1,
    },
  }
}

const SectionOutputDivisionModal = ({ open, onClose, divisionType, setDivisionType }) => {

  const [localDivisionType, setLocalDivisionType] = React.useState(divisionType)
  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleClick = (event) => setAnchorEl(event.currentTarget)
  const handleClose = () => setAnchorEl(null)

  const openPopover = Boolean(anchorEl)
  return (
    <SectionOutputModal
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiPaper-rounded": {
          width: 636,
        },
      }}
      title={<>
        Configurez le type de division que vous souhaitez.
        <img className="pointer" alt="help" src="/icons/packaging-help.svg" onClick={handleClick} style={{ height: 24 }} />
        <Popover
          arrow
          open={openPopover}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          transformOrigin={{ vertical: "top", horizontal: "center" }}
          sx={popoverStyles}
        >
          <div
            className="flexColumn" style={{ gap: 8, lineHeight: "22px" }}
          >
            <div className="flexRow noWrap" style={{ fontSize: 16 }}>
              <span style={{ lineHeight: "24px" }}>Quel usage pour chaque type division ?</span>
              <CloseIcon sx={{ color: COLORS.WHITE, cursor: "pointer" }} size="small" onClick={handleClose} />
            </div>
            <div>
              Par ingrédients : Permet par exemple de séparer une viande de sa sauce
            </div>
            <div>
              Par pourcentage : Permet de diviser une sauce en 3.
            </div>

          </div>
        </Popover>
      </>
      }
      disabled={!localDivisionType}
      onValidate={() => {
        setDivisionType(localDivisionType)
      }}
    >
      <span style={{ marginTop: 2, color: COLORS.BLACK800 }} >Type de division</span>
      <RadioGroup sx={{ gap: "8px" }} value={localDivisionType} onChange={(e) => setLocalDivisionType(e.target.value)}>
        {[["ingredient", "Par ingrédients"], ["percentage", "Par pourcentage"]].map(([value, label]) => <FormControlLabel
          key={value}
          value={value}
          label={label}
          control={<Radio color="secondary" />}
          color="blue"
          sx={{ "& .MuiFormControlLabel-label": { color: "#555", fontSize: 14 }, "& .MuiRadio-root": { padding: "0 8px 0 6px" } }}
        />)}
      </RadioGroup>
    </SectionOutputModal >
  )
}

export default SectionOutputDivisionModal